/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Coordinate } from 'ol/coordinate';
import { Extent } from 'ol/extent';

import { CustomGeoPosition, DisplayFeaturePayload, LaunchStreetViewPayload, MaxZoomPayload } from './active-map.model';

export interface DisplayFeatureStateModifier {
    payload: DisplayFeaturePayload;
}

export class InitializeMapState {
    static readonly type = '[MapConfig] Initialize map state from MapConfigState';

    constructor(
        public payload: {
            center: Coordinate;
            extent: Extent;
            zoom: number;
        }
    ) {}
}

export class MapCreated {
    static readonly type = '[MapService] Openlayers map created';
}

export class MapDestroyed {
    static readonly type = '[MapService] Map destroyed';
}

export class GoogleMapInitialized {
    static readonly type = '[Map Service] Google Maps API Initialized';
}


export class ReloadMap {
    static readonly type = '[Map] Reload Map';
}

export class RefreshMap {
    static readonly type = '[Map] Refresh map';
}

export class SetMapCenter {
    static readonly type = '[MapService] Set map center';

    constructor(public payload: Coordinate) {}
}

export class SetMapExtent {
    static readonly type = '[MapService] Set map extent';

    constructor(public payload: Extent) {}
}

export class SetMapZoom {
    static readonly type = '[MapService] Set map zoom level';

    constructor(public payload: { zoom: number; scale: number }) {}
}

export class SetGoogleMapType {
    static readonly type = '[Map] Set GoogleMaps MapType';

    constructor(public payload: string) {}
}

export class SetGoogleMaxImageryZoom {
    static readonly type = '[Map] Set GoogleMaps max zoom';

    constructor(public payload: MaxZoomPayload) {}
}

export class EnableMapTip {
    static readonly type = '[Map] Enable maptip';
}

export class DisableMapTip {
    static readonly type = '[Map] Disable maptip';
}

export class ToggleMapTipEnabled {
    static readonly type = '[Map] Toggle maptips';
}

export class UserSelection {
    static readonly type = '[Map] User selected map feature(s)';
}

export class SetLayerDisplayFeatures {
    static readonly type = '[Map] Set layer display featureIds';

    constructor(public payload: DisplayFeaturePayload) {}
}

export class MergeLayerDisplayFeatures {
    static readonly type = '[Map] Merge layer display featureIds';

    constructor(public payload: DisplayFeaturePayload) {}
}

export class SetGeolocationPosition {
    static readonly type = '[Map] Set Geolocation';

    constructor(public payload: CustomGeoPosition) {}
}

export class EnableGeolocation {
    static readonly type = '[Map] Enable Geolocation';
}

export class DisableGeolocation {
    static readonly type = '[Map] Disable Geolocation';
}

export class ResetMapState {
    static readonly type = '[Map] Reset to default state';
}

export class LaunchStreetView {
    static readonly type = '[Map] Launch Street View';

    constructor(public payload: LaunchStreetViewPayload) {}
}

export class CopyCoordinates {
    static readonly type = '[Map] Copy Lat/Lon Coordinates';

    constructor(public coordinates: Coordinate) {}
}

